import { initMobileNavigation } from '.';
initMobileNavigation();
